<div class="basic-info" [ngClass]="{'error': hasError}">
  <div *ngIf="banner" class="pb-3 text-center banner">
    <img *ngIf="isImageBanner" width="375" [src]="banner" alt="banner" height="183">
    <div class="video-panel" *ngIf="!isImageBanner">
      <video controls name="media" height="183">
        <source [src]="banner">
      </video>
    </div>
  </div>
  <!-- <div *ngIf="paragraph" class="pb-3 text-center">
    <p class="paragraph white-space-text-area-newline" [innerHtml]="paragraph"><span class="color-error">{{isRequired}}</span>
    </p> 
   </div> -->

  <p class="paragraph pb-3">
    <span class="color-grey-500 mb-3 new-inner-html new-inner-html-list">
      <span class="color-error float-right">{{isRequired}}</span>
      <app-content-card
        [cmt]="paragraph"
        [showChar]="350"
        readMoreCss="cursor-pointer color-blue"
        readLessCss="cursor-pointer color-blue"
        [readMoreText]="mls.languageText.survey_detail.key2"
        [readLessText]="mls.languageText.survey_detail.key3"
        class="survey">
      </app-content-card>
    </span>
  </p>

  <div *ngIf="content">
    <ng-content></ng-content>
  </div>
</div>
